// extracted by mini-css-extract-plugin
export default {"frame":"Frame_frame__uTbir","editButton":"Frame_editButton__d5l3h"};